import { store } from 'quasar/wrappers';
import { createStore } from 'vuex';

import {
  application,
  category,
  location,
  payment,
  order,
  user,
} from 'quasar-pilot-core';
import layout from './layout';

export default store((/* { ssrContext } */) => createStore({
  modules: {
    application,
    category,
    location,
    payment,
    order,
    user,
    layout,
  },
  // enable strict mode (adds overhead!)
  // for dev mode and --debug builds only
  strict: process.env.DEBUGGING,
}));
